import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Edit, Save, X } from 'lucide-react';



const StructureItem = ({ item, type, onEdit }) => {

  const { t } = useTranslation('setup');

  const [isEditing, setIsEditing] = useState(false);

  const [editData, setEditData] = useState({});



  const getTypeLabel = () => {

    return t(`structureItem.types.${type}`, { defaultValue: type });

  };



  const getDisplayName = () => {

    if (type === 'bed') {

      return item.bedNumber || item.number || `${getTypeLabel()} ${item.id?.substring(0, 8)}`;

    }

    return item.name || item.number || item.shortname || `${getTypeLabel()} ${item.id?.substring(0, 8)}`;

  };



  const handleEdit = () => {

    if (type === 'bed') {

      setEditData({ bedNumber: item.bedNumber || item.number || '' });

    } else {

      setEditData({ name: item.name || '' });

    }

    setIsEditing(true);

  };



  const handleSave = async () => {

    try {

      await onEdit(editData);

      setIsEditing(false);

    } catch (error) {

      console.error('Error saving:', error);

    }

  };



  const handleCancel = () => {

    setEditData({});

    setIsEditing(false);

  };



  const handleFieldChange = (field, value) => {

    setEditData(prev => ({ ...prev, [field]: value }));

  };



  const editField = type === 'bed' ? 'bedNumber' : 'name';

  const editLabel = type === 'bed' ? t('structureItem.fields.bedNumber') : t('structureItem.fields.name');

  const editValue = type === 'bed' ? (editData.bedNumber || '') : (editData.name || '');



  return (

    <div className="structure-item" style={{ 

      padding: '16px', 

      border: '1px solid #e0e0e0', 

      borderRadius: '8px',

      background: '#fafafa'

    }}>

      {isEditing ? (

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>

          <div className="form-group">

            <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>

              {editLabel}

            </label>

            <input

              type="text"

              value={editValue}

              onChange={(e) => handleFieldChange(editField, e.target.value)}

              style={{ 

                width: '100%', 

                padding: '8px 12px', 

                border: '1px solid #ddd', 

                borderRadius: '6px',

                fontSize: '14px'

              }}

            />

          </div>

          

          <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>

            <button

              type="button"

              onClick={handleSave}

              className="btn btn-primary"

              style={{ 

                padding: '8px 16px', 

                fontSize: '14px',

                display: 'flex',

                alignItems: 'center',

                gap: '6px'

              }}

            >

              <Save size={16} />

              {t('structureItem.save')}

            </button>

            <button

              type="button"

              onClick={handleCancel}

              className="btn btn-secondary"

              style={{ 

                padding: '8px 16px', 

                fontSize: '14px',

                display: 'flex',

                alignItems: 'center',

                gap: '6px'

              }}

            >

              <X size={16} />

              {t('structureItem.cancel')}

            </button>

          </div>

        </div>

      ) : (

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

          <div>

            <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>

              {getTypeLabel()}

            </div>

            <div style={{ fontSize: '16px', fontWeight: '500', color: '#333' }}>

              {getDisplayName()}

            </div>

          </div>

          <button

            type="button"

            onClick={handleEdit}

            className="btn btn-secondary"

            style={{ 

              padding: '6px 12px', 

              fontSize: '13px',

              display: 'flex',

              alignItems: 'center',

              gap: '6px'

            }}

          >

            <Edit size={14} />

            {t('structureItem.edit')}

          </button>

        </div>

      )}

    </div>

  );

};



export default StructureItem;

